import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SortableContainer } from 'react-sortable-hoc';
import { showModal } from '../../../../actions/ModalActions';
import {
  getHomepageSections,
  editHomepageSection,
} from '../../../../actions/website/entities/HomepageSectionActions';
import { moveEntity, resetEntities, addEntity } from '../../../../actions/website/EntityActions';
import EditPageHeader from './EditPageCommon/EditPageHeader';
import WeddingInfoForm from './WeddingInfoForm';
import HomepageForm from './HomepageForm';
import Accordion from '../../../common/ui/Accordion';

class HomepageSections extends Component {
  componentDidMount() {
    const { getHomepageSectionEntities } = this.props;
    getHomepageSectionEntities();
  }

  componentWillUnmount() {
    const { unloadEntities } = this.props;
    unloadEntities();
  }

  render() {
    const {
      homepageSections,
      orderedIds,
      openModal,
      onEdit,
      onDelete,
      page,
      themeKey,
    } = this.props;

    const weddingAccordionItems = [
      {
        heading: 'Wedding Summary',
        body: WeddingInfoForm,
        props: { page },
      },
    ];

    return (
      <div>
        {themeKey && (
          <EditPageHeader entityName="Story" onAdd={openModal} page={page} themeKey={themeKey} />
        )}

        <div className="wedding-form-accordion">
          <Accordion items={weddingAccordionItems} />
        </div>

        <HomepageForm
          page={page}
          onEdit={onEdit}
          onDelete={onDelete}
          homepageSections={homepageSections}
          orderedIds={orderedIds}
          openModal={openModal}
        />
      </div>
    );
  }
}

HomepageSections.propTypes = {
  homepageSections: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getHomepageSectionEntities: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  page: PropTypes.shape({}),
  themeKey: PropTypes.string,
};

const mapStateToProps = state => ({
  homepageSections: state.website.entities.byId,
  orderedIds: state.website.entities.orderedIds,
  page: state.website.pages.byId[state.website.pages.typeToId.HOME],
  themeKey: state.wedding.theme.key,
});

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => {
    dispatch(moveEntity(oldIndex, newIndex));
  },
  openModal: () => {
    dispatch(addEntity());
    dispatch(showModal('HOMEPAGE_SECTION', {}, { size: 'md' }));
  },
  getHomepageSectionEntities: () => {
    dispatch(getHomepageSections());
  },
  onEdit: faq => {
    dispatch(editHomepageSection(faq));
    dispatch(showModal('HOMEPAGE_SECTION', { isUpdate: true }, { size: 'md' }));
  },
  onDelete: entity => {
    dispatch(showModal('DELETE_ENTITY', { entity }));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
});

const SortableHomepageSections = SortableContainer(HomepageSections);

export default connect(mapStateToProps, mapDispatchToProps)(SortableHomepageSections);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/HomepageSections.jsx